import { useEffect, useState } from 'react';

import api from '../api';
import { useNotification } from './useNotification';

const usePreviewUrl = (rawUrl?: string): string => {
  const [previewUrl, setPreviewUrl] = useState('');
  const { addError } = useNotification();

  useEffect(() => {
    if (!rawUrl) return;

    const setUrl = async () => {
      try {
        const preview = await api.get(rawUrl);

        setPreviewUrl(preview?.data?.assetUrl);
      } catch {
        addError('There was a problem loading the preview.');
      }
    };

    setUrl();
  }, [rawUrl, addError]);

  return previewUrl;
};

export default usePreviewUrl;
